// extracted by mini-css-extract-plugin
module.exports = {"container":"GosuslugyEducation_container__31gfl","filters":"GosuslugyEducation_filters__3wvPa"};